import React from "react";
import styles from "./AdminBillingSubscription.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import { useNavigate } from "react-router-dom";
import BillingCard from "../../../../components/BillingCard/BillingCard";
import profile from "../../../../assets/images/profile.png";
import building from "../../../../assets/images/building.png";
import rocket from "../../../../assets/images/rocket.png";
import Switch from "../../../../components/Switch/Switch";
import HeadingComponent from "../../../../components/HeadingComponent/HeadingComponent";

const AdminBillingSubscription = () => {
  const navigate = useNavigate();

  const CardData = [
    {
      title: "Craftsman",
      logo: profile,
      price: "$7",
      list: [
        "Attendance Management",
        "Leave System Management",
        "Chat Support",
        "Expense Tracking",
        "Invoice Generate",
        "Purchase Generate",
        "Leave System Management",
      ],
    },
    {
      title: "Wholesale",
      price: "$50",
      logo: building,

      list: [
        "Number of licenses used  ",
        "Subscription tier label  .",
        "Subscription renewal date",
      ],
    },
    {
      title: "Commercial",
      logo: building,

      price: "$75",
      list: [
        "Number of licenses used  ",
        "Subscription tier label  .",
        "Subscription renewal date",
      ],
    },
    {
      title: "Professional",
      price: "$95",
      logo: rocket,
      list: [
        "Attendance Management",
        "Leave System Management",
        "Chat Support",
        "Expense Tracking",
        "Invoice Generate",
        "Purchase Generate",
        "Leave System Management",
      ],
    },
  ];
  return (
    <div className={styles.mainCont}>
      <div className={styles.HeadingDiv}>
        <TextComponent
          className={styles.Heading}
          text={"Billing & Subscription"}
        />
        <div className={styles.ButtonDiv}>
          <SubmitButton
            btnContainerClass={styles.btnContainer}
            btnClass={styles.btnClass}
            secondary
            title={"Payment Methods"}
            onClick={() =>
              navigate("/AdminBuisnessManagement/SelectPaymentMethod")
            }
          />
          {/* <SubmitButton
            btnContainerClass={styles.btnContainer}
            btnClass={styles.btnClass}
            primary
            title={"Monthly"}
          />
          <SubmitButton
            btnContainerClass={styles.btnContainer}
            btnClass={styles.btnClass}
            primary
            title={"Annually"}
          /> */}
        </div>
      </div>
      <div className={styles.subCont}>
        <div className={styles.row}>
          <div className={styles.mini_row}>
            <TextComponent
              text={"Monthly"}
              color={"var(--text-secondary-color)"}
              fontFamily={"Inter-semibold"}
            />

            <Switch
              activeColor={"#F39C12"}
              inactiveColor={" #78788029"}
              size="small"
            />
            {/* <Switch defaultChecked onChange={onChange} handleBg={"#F39C12"} /> */}
            <TextComponent
              text={"Annually"}
              fontFamily={"Inter-semibold"}
              color={"var(--text-secondary-color)"}
            />
          </div>
        </div>
        <BillingCard
          Options={CardData}
          isNavigate
          onClick={() =>
            navigate("/AdminBuisnessManagement/SelectPaymentMethod")
          }
        />
        <SubmitButton
          btnContainerClass={styles.LicensebtnContainer}
          btnClass={styles.LicensebtnClass}
          title={"Buy more License "}
          onClick={() => navigate("/AddUserLicense")}
          primary
        />
      </div>
    </div>
  );
};

export default AdminBillingSubscription;
